import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { ShieldCheck, MousePointerClick } from "lucide-react";
import RoleSwitcher from "./RoleSwitcher";
import CelebrationOverlay from "./CelebrationOverlay";

export default function MobileFrame() {
  const { pathname } = useLocation();
  const hideSwitcher = ["/", "/onboarding", "/auth"].includes(pathname);

  return (
    <div className="gd-stage">
      <div className="gd-desk-copy">
        <div className="mb-6 inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-2 text-xs font-bold text-white/80 backdrop-blur">
          <ShieldCheck size={15} className="text-[#f5911e]" /> Safety First Neighborhood Work for our Youth ages 7-17
        </div>
        <h1 className="text-5xl font-black leading-tight text-white">
          GEN<span className="text-[#f5911e]">-DO</span>
        </h1>
        <p className="mt-4 text-lg font-semibold text-white/90">The Neighborhood Hustle Platform</p>
        <p className="mt-4 text-sm leading-relaxed text-white/70">
          Kids complete real neighborhood jobs, earn money, and rank up from Associate to CEO — while every
          poster passes a background check and every job is parent-approved.
        </p>
        <div className="mt-8 flex items-center gap-2 text-sm text-white/60">
          <MousePointerClick size={16} className="text-[#f5911e]" />
          Interactive demo — tap through the phone
        </div>
      </div>

      <div className="gd-phone">
        <div className="gd-notch" />
        <Outlet />
        {!hideSwitcher && <RoleSwitcher />}
        <CelebrationOverlay />
      </div>
    </div>
  );
}
